import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class FiscalYearService {

  constants: Constants = new Constants();

  constructor(private readonly http: HttpClient) { }

  getFiscalYearList(): Observable<any> {
    console.info("Entered getFiscalYearList()");

    const httpCustomOptions = {
      headers: new HttpHeaders({
        //  'Accept': 'application/json',
        // 'Content-Type': 'application/json, application/x-www-form-urlencoded;charset=ISO-8859-15'        
      })
    };
    return this.http
      .get(this.constants.getApiBasePath() + `/api/v1/getfiscalyears`, httpCustomOptions)
      .pipe(
        tap(_ => this.log('data success')),
        catchError(this.handleError<any>('data fails'))
      );
  }

  addFiscalYear(arrData: any): Observable<any> {
    console.info("Entered addFiscalYear()");
	  const headers = new HttpHeaders().set('Content-Type', 'application/json');
	  return this.http
    	.post(this.constants.getApiBasePath() + '/api/v1/fiscalyear/add', arrData, { headers, responseType: 'text' })
		.pipe(
			tap(_ => this.log('data success')),
			catchError(this.handleError<any>('data fails'))
		);
  }

  private handleError<T>(_operation, result?: T) {
		return (error: any): Observable<T> => {
			console.info(error); // log to console instead
			return of(result as T);
		};
	}

	/** Log a message */
	private log(message: string) {
		console.info('Message: ' + message);
	}
}
